import Vue from "vue";
import VueRouter from "vue-router";
import Toasted from "vue-toasted";
import BootstrapVue from "bootstrap-vue";
import VueClipboard from "vue-clipboard2";
import Cryptoicon from "vue-cryptoicon";
import { Btc, Eth, Xrp, Eos, Bnb, Gusd, Usdt } from "vue-cryptoicon/src/icons";
import firebase from "firebase/app";
import "firebase/database";
import Donut from "vue-css-donut-chart";
import "vue-css-donut-chart/dist/vcdonut.css";
import VueContentPlaceholders from "vue-content-placeholders";

import App from "./App.vue";
import router from "./router/index";
import { store } from "@/store/index";
import { HTTP } from "@/services/http";
// import Quasar from "quasar/dist/quasar.esm.js";
// import "quasar/dist/quasar.min.css";
import "./registerServiceWorker";

Vue.prototype.$http = HTTP;

const firebaseConfig = {
  apiKey: "AIzaSyBWMYFP-39qDmpp8zICPQRBjQOgiBi3SgM",
  authDomain: "mlm-platforms.firebaseapp.com",
  databaseURL: "https://mlm-platforms-default-rtdb.firebaseio.com",
  projectId: "mlm-platforms",
  storageBucket: "mlm-platforms.appspot.com",
  messagingSenderId: "472171166425",
  appId: "1:472171166425:web:1dfdd4dd9704014b911cc8"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
export const database = firebase.database;
export const serverBus = new Vue();

Cryptoicon.add([Btc, Eth, Xrp, Eos, Bnb, Gusd, Usdt]);

Vue.config.productionTip = false;
Vue.use(VueClipboard);
// Vue.use(Quasar);
Vue.use(BootstrapVue);
Vue.use(VueRouter);
Vue.use(Toasted);
Vue.use(Cryptoicon);
Vue.use(Donut);
Vue.use(VueContentPlaceholders);

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
